import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buyer-bookings',
  templateUrl: './buyer-bookings.component.html',
  styleUrls: ['./buyer-bookings.component.css']
})
export class BuyerBookingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
